<template>
  <div class="unsubscribe">
    <p class="unsubscribe__text">{{ $t("unsubscribe text") }}</p>
    <router-link to="/finance" class="unsubscribe__button button filled">{{
      $t("personal account")
    }}</router-link>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.unsubscribe {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.unsubscribe__text {
  font-size: 25px;
  color: #2f3a57;
}

.unsubscribe__button {
  margin-top: 30px;
  max-width: 150px;
  padding: 10px 20px;
  font-size: 15px;
  text-decoration: none;
}
</style>
